import {
  TSearchOffersDesktopModel,
  TSearchOffersDesktopRequestSchema,
  TSearchOffersDesktopResponseSchema,
} from '../../../repositories/search-offers/v2/search-offers-desktop';
import { IHttpApi } from '@cian/http-api/shared';

export function getOffers(
  httpApi: IHttpApi,
  parameters: TSearchOffersDesktopRequestSchema,
  currentSubdomain: string,
): Promise<TSearchOffersDesktopResponseSchema> {
  const defaultConfig: TSearchOffersDesktopModel = {
    apiType: 'private',
    assertStatusCodes: [200, 400],
    method: 'POST',
    microserviceName: 'newbuildingSearch',
    pathApi: '/v1/get-newbuildings-for-serp/',
  };

  const config: TSearchOffersDesktopModel = Object.assign({}, defaultConfig, {
    parameters: {
      subdomain: currentSubdomain,
      uri: '/novostroyki/',
      page: 1,
      ...parameters,
    },
  });

  return httpApi.fetch(
    // Typescript воспринимает parameters как ISearchOffersDesktopJsonQueryRequestSchema,
    // но хочет поля из ISearchOffersDesktopPathRequestSchema
    // tslint:disable-next-line:no-any
    config as any,
    undefined,
  );
}
